import React, { useState } from 'react';
import styles from './FormMultipleServerSearch.module.scss';

import { useFormContext, Controller } from 'react-hook-form';

import ServerSearchFieldWithTags from 'components/ServerSearchFieldWithTags';

import clsx from 'clsx';
import { allKeyboardLatSymbols, pluck } from 'helpers/AppHelpers';
import { searchLooseItems } from 'actions/commonActions';
import { useDispatch } from 'react-redux';

export default function FormMultipleLooseItemSearch({
  name,
  listName,
  className,
  getQueryOptions
}) {
  const dispatch = useDispatch();

  const [options, setOptions] = useState([]);

  const { control, clearErrors, setValue } = useFormContext();

  const selectOption = (looseItems, isInvalid) => {
    isInvalid && clearErrors(name);
    setValue(name, pluck(looseItems, 'id'));
    setValue(listName, looseItems);
    !looseItems?.length && setOptions([]);
  };

  const changeInput = (searchQuery) => {
    const value = searchQuery ? searchQuery.replace(allKeyboardLatSymbols, '') : '';
    if (value === '') return;

    const filter = getQueryOptions(searchQuery);

    dispatch(searchLooseItems(filter)).then((res) => setOptions(res || []));
  };

  return (
    <Controller
      name={listName}
      control={control}
      render={({ field: { value }, fieldState: { error } }) => (
        <div className={clsx(className, styles.input_wrapper)}>
          <ServerSearchFieldWithTags
            getLabel={(option) => option?.name}
            fieldValue={value || []}
            options={options}
            onInputChange={changeInput}
            onSelect={(data) => selectOption(data, !!error)}
          />
          {!!error && <span>{error.message}</span>}
        </div>
      )}
    />
  );
}
